'use strict';

var EditConditionalDns = require('actionGroups/conditionalDns/ConditionalDns');

module.exports = {
  Model: EditConditionalDns,
};
